module.exports = __webpack_public_path__ + "img/IMG_2629.f77a0969.jpg";